// extracted by mini-css-extract-plugin
module.exports = {"bkw-M":"M_bkw-M__yXri8"};